export const testOutput = {
  '**見積番号': '30090006-00',
  '**見積親番': 30090006,
  '**見積枝番': 0,
  '**見積日付': '2022-9-13',
  '**見積名称': '○×建設様お見積り',
  '**都道府県': '埼玉県',
  '**市区町村': 'さいたま市',
  '**顧客名称': '株式会社○×建設',
  '**一次店名称': '応研株式会社',
  '**一次店担当者名称': '佐藤敏夫',
  '**二次店名称': 'キヤノンシステムアンドサポート株式会社',
  '**二次店担当者名称': '須藤誠也',
  '**支払条件': '基本取引契約通り',
  '**有効期限': '見積日付より３０日以内',
  '**納入予定日': 'スケジュール表の通り',
  '**保守契約内容': '次回保守継続　必須',
  '**ライセンス数': 10,
  '**備考①': '同時アクセス10台',
  '**備考②': '有',
  '**備考③': '有（見積番号100）',
  '**契約期間': '１年',
  '**拠点名称': '東京支店',
  '**拠点住所': '東京都千代田区内幸町1-3-3',
  '**拠点電話番号': '03-4400-1033',
  '**拠点FAX番号': '03-6667-6063',
  '**担当者名称': 'どっと太郎',
  '**担当者メールアドレス': 't.dot@kendweb.net',
  '**仕切金額合計': 2729350,
  '**標準金額合計': 4661800,
  '**明細-行番号_1': 1,
  '**明細-名称_1': '＜ソフトウェア＞',
  '**明細-数量_1': '',
  '**明細-標準単価_1': '',
  '**明細-標準金額_1': '',
  '**明細-仕切率_1': '',
  '**明細-仕切単価_1': '',
  '**明細-仕切金額_1': '',
  '**明細-保守金額_1': '',
  '**明細-備考①_1': '',
  '**明細-行番号_2': 2,
  '**明細-名称_2': 'どっと原価NEO EX基本ﾓｼﾞｭｰﾙ for 大臣',
  '**明細-数量_2': 1,
  '**明細-標準単価_2': 800000,
  '**明細-標準金額_2': 800000,
  '**明細-仕切率_2': 0.49,
  '**明細-仕切単価_2': 392000,
  '**明細-仕切金額_2': 392000,
  '**明細-保守金額_2': 120000,
  '**明細-備考①_2': '2865V26701',
  '**明細-行番号_3': 3,
  '**明細-名称_3': 'どっと原価NEO EX見積作成ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_3': 1,
  '**明細-標準単価_3': 250000,
  '**明細-標準金額_3': 250000,
  '**明細-仕切率_3': 0.49,
  '**明細-仕切単価_3': 122500,
  '**明細-仕切金額_3': 122500,
  '**明細-保守金額_3': 38400,
  '**明細-備考①_3': '2796V22201',
  '**明細-行番号_4': 4,
  '**明細-名称_4': 'どっと原価NEO EX発注管理ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_4': 1,
  '**明細-標準単価_4': 250000,
  '**明細-標準金額_4': 250000,
  '**明細-仕切率_4': 0.49,
  '**明細-仕切単価_4': 122500,
  '**明細-仕切金額_4': 122500,
  '**明細-保守金額_4': 38400,
  '**明細-備考①_4': '2796V22301',
  '**明細-行番号_5': 5,
  '**明細-名称_5': 'どっと原価NEO EX日報管理ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_5': 1,
  '**明細-標準単価_5': 250000,
  '**明細-標準金額_5': 250000,
  '**明細-仕切率_5': 0.49,
  '**明細-仕切単価_5': 122500,
  '**明細-仕切金額_5': 122500,
  '**明細-保守金額_5': 38400,
  '**明細-備考①_5': '3865V26801',
  '**明細-行番号_6': 6,
  '**明細-名称_6': 'どっと原価NEO EX支払管理ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_6': 1,
  '**明細-標準単価_6': 250000,
  '**明細-標準金額_6': 250000,
  '**明細-仕切率_6': 0.49,
  '**明細-仕切単価_6': 122500,
  '**明細-仕切金額_6': 122500,
  '**明細-保守金額_6': 38400,
  '**明細-備考①_6': '2865V26901',
  '**明細-行番号_7': 7,
  '**明細-名称_7': 'どっと原価NEO EX会計連動ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_7': 1,
  '**明細-標準単価_7': 200000,
  '**明細-標準金額_7': 200000,
  '**明細-仕切率_7': 0.49,
  '**明細-仕切単価_7': 98000,
  '**明細-仕切金額_7': 98000,
  '**明細-保守金額_7': 30000,
  '**明細-備考①_7': '2865V27001',
  '**明細-行番号_8': 8,
  '**明細-名称_8': 'どっと原価NEO EX原価配賦ｵﾌﾟｼｮﾝ for 大臣',
  '**明細-数量_8': 1,
  '**明細-標準単価_8': 250000,
  '**明細-標準金額_8': 250000,
  '**明細-仕切率_8': 0.49,
  '**明細-仕切単価_8': 122500,
  '**明細-仕切金額_8': 122500,
  '**明細-保守金額_8': 38400,
  '**明細-備考①_8': '2796V23201',
  '**明細-行番号_9': 9,
  '**明細-名称_9': 'どっと原価NEO EX会計ERPﾓｼﾞｭｰﾙ for 大臣',
  '**明細-数量_9': 1,
  '**明細-標準単価_9': 150000,
  '**明細-標準金額_9': 150000,
  '**明細-仕切率_9': 0.49,
  '**明細-仕切単価_9': 73500,
  '**明細-仕切金額_9': 73500,
  '**明細-保守金額_9': 22800,
  '**明細-備考①_9': '2865V28501',
  '**明細-行番号_10': 10,
  '**明細-名称_10': 'どっと原価NEO EX見積読込ﾓｼﾞｭｰﾙ(汎用ﾀｲﾌﾟ) for 大臣',
  '**明細-数量_10': 1,
  '**明細-標準単価_10': 100000,
  '**明細-標準金額_10': 100000,
  '**明細-仕切率_10': 0.49,
  '**明細-仕切単価_10': 49000,
  '**明細-仕切金額_10': 49000,
  '**明細-保守金額_10': 15600,
  '**明細-備考①_10': '',
  '**明細-行番号_11': 11,
  '**明細-名称_11': 'どっと原価NEO EXCELﾌﾘｰﾓｼﾞｭｰﾙ for 大臣',
  '**明細-数量_11': 1,
  '**明細-標準単価_11': 100000,
  '**明細-標準金額_11': 100000,
  '**明細-仕切率_11': 0.49,
  '**明細-仕切単価_11': 49000,
  '**明細-仕切金額_11': 49000,
  '**明細-保守金額_11': 15600,
  '**明細-備考①_11': '3037V34901',
  '**明細-行番号_12': 12,
  '**明細-名称_12': '＜　小　計　＞',
  '**明細-数量_12': '',
  '**明細-標準単価_12': '',
  '**明細-標準金額_12': 2600000,
  '**明細-仕切率_12': '',
  '**明細-仕切単価_12': '',
  '**明細-仕切金額_12': 1274000,
  '**明細-保守金額_12': 396000,
  '**明細-備考①_12': '',
  '**明細-行番号_13': 13,
  '**明細-名称_13': '＜テンプレート＞',
  '**明細-数量_13': '',
  '**明細-標準単価_13': '',
  '**明細-標準金額_13': '',
  '**明細-仕切率_13': '',
  '**明細-仕切単価_13': '',
  '**明細-仕切金額_13': '',
  '**明細-保守金額_13': '',
  '**明細-備考①_13': '',
  '**明細-行番号_14': 14,
  '**明細-名称_14': 'どっと原価NEO EX注文請書管理 for 大臣',
  '**明細-数量_14': 1,
  '**明細-標準単価_14': 200000,
  '**明細-標準金額_14': 200000,
  '**明細-仕切率_14': 0.75,
  '**明細-仕切単価_14': 150000,
  '**明細-仕切金額_14': 150000,
  '**明細-保守金額_14': 31200,
  '**明細-備考①_14': '3546V07301',
  '**明細-行番号_15': 15,
  '**明細-名称_15': 'どっと原価NEO EX在庫管理 for 大臣',
  '**明細-数量_15': 1,
  '**明細-標準単価_15': 200000,
  '**明細-標準金額_15': 200000,
  '**明細-仕切率_15': 0.75,
  '**明細-仕切単価_15': 150000,
  '**明細-仕切金額_15': 150000,
  '**明細-保守金額_15': 31200,
  '**明細-備考①_15': '3546V07401',
  '**明細-行番号_16': 16,
  '**明細-名称_16': 'どっと原価NEO EX出来高請求 for 大臣',
  '**明細-数量_16': 1,
  '**明細-標準単価_16': 100000,
  '**明細-標準金額_16': 100000,
  '**明細-仕切率_16': 0.75,
  '**明細-仕切単価_16': 75000,
  '**明細-仕切金額_16': 75000,
  '**明細-保守金額_16': 15600,
  '**明細-備考①_16': '3546V07801',
  '**明細-行番号_17': 17,
  '**明細-名称_17': '＜　小　計　＞',
  '**明細-数量_17': '',
  '**明細-標準単価_17': '',
  '**明細-標準金額_17': 500000,
  '**明細-仕切率_17': '',
  '**明細-仕切単価_17': '',
  '**明細-仕切金額_17': 375000,
  '**明細-保守金額_17': 78000,
  '**明細-備考①_17': '',
  '**明細-行番号_18': 18,
  '**明細-名称_18': '＜ライセンス＞',
  '**明細-数量_18': '',
  '**明細-標準単価_18': '',
  '**明細-標準金額_18': '',
  '**明細-仕切率_18': '',
  '**明細-仕切単価_18': '',
  '**明細-仕切金額_18': '',
  '**明細-保守金額_18': '',
  '**明細-備考①_18': '',
  '**明細-行番号_19': 19,
  '**明細-名称_19': 'どっと原価NEO EXｸﾗｲｱﾝﾄﾗｲｾﾝｽｾｯﾄ(10C) for 大臣',
  '**明細-数量_19': 1,
  '**明細-標準単価_19': 350000,
  '**明細-標準金額_19': 350000,
  '**明細-仕切率_19': 0.49,
  '**明細-仕切単価_19': 171500,
  '**明細-仕切金額_19': 171500,
  '**明細-保守金額_19': 52800,
  '**明細-備考①_19': '2865V28801',
  '**明細-行番号_20': 20,
  '**明細-名称_20': '＜　小　計　＞',
  '**明細-数量_20': '',
  '**明細-標準単価_20': '',
  '**明細-標準金額_20': 350000,
  '**明細-仕切率_20': '',
  '**明細-仕切単価_20': '',
  '**明細-仕切金額_20': 171500,
  '**明細-保守金額_20': '',
  '**明細-備考①_20': '',
  '**明細-行番号_21': 21,
  '**明細-名称_21': '＜ユースウェア＞',
  '**明細-数量_21': '',
  '**明細-標準単価_21': '',
  '**明細-標準金額_21': '',
  '**明細-仕切率_21': '',
  '**明細-仕切単価_21': '',
  '**明細-仕切金額_21': '',
  '**明細-保守金額_21': '',
  '**明細-備考①_21': '',
  '**明細-行番号_22': 22,
  '**明細-名称_22': '【△】どっと原価NEO EXどっと原価 基本操作A(3時間×3回) for 大臣',
  '**明細-数量_22': 1,
  '**明細-標準単価_22': 280000,
  '**明細-標準金額_22': 280000,
  '**明細-仕切率_22': 0.75,
  '**明細-仕切単価_22': 210000,
  '**明細-仕切金額_22': 210000,
  '**明細-保守金額_22': '',
  '**明細-備考①_22': '2796V24201',
  '**明細-行番号_23': 23,
  '**明細-名称_23': 'どっと原価NEO EX初回指導(3時間×1回) for 大臣',
  '**明細-数量_23': 1,
  '**明細-標準単価_23': 150000,
  '**明細-標準金額_23': 150000,
  '**明細-仕切率_23': 0.75,
  '**明細-仕切単価_23': 112500,
  '**明細-仕切金額_23': 112500,
  '**明細-保守金額_23': '',
  '**明細-備考①_23': '3427V12601',
  '**明細-行番号_24': 24,
  '**明細-名称_24': 'どっと原価NEO EXｿﾌﾄｳｪｱｲﾝｽﾄｰﾙ支援(ｻｰﾊﾞｰｺｰｽ) for 大臣',
  '**明細-数量_24': 1,
  '**明細-標準単価_24': 50000,
  '**明細-標準金額_24': 50000,
  '**明細-仕切率_24': 0.75,
  '**明細-仕切単価_24': 37500,
  '**明細-仕切金額_24': 37500,
  '**明細-保守金額_24': '',
  '**明細-備考①_24': '2796V24901',
  '**明細-行番号_25': 25,
  '**明細-名称_25': 'どっと原価NEO EXｿﾌﾄｳｪｱｲﾝｽﾄｰﾙ支援(ｸﾗｲｱﾝﾄｺｰｽ) for 大臣',
  '**明細-数量_25': 5,
  '**明細-標準単価_25': 10000,
  '**明細-標準金額_25': 50000,
  '**明細-仕切率_25': 0.75,
  '**明細-仕切単価_25': 7500,
  '**明細-仕切金額_25': 37500,
  '**明細-保守金額_25': '',
  '**明細-備考①_25': '2796V25001',
  '**明細-行番号_26': 26,
  '**明細-名称_26': '[使用不可]導入事前分析ｻﾎﾟｰﾄ for 大臣',
  '**明細-数量_26': 1,
  '**明細-標準単価_26': 150000,
  '**明細-標準金額_26': 150000,
  '**明細-仕切率_26': 0.75,
  '**明細-仕切単価_26': 112500,
  '**明細-仕切金額_26': 112500,
  '**明細-保守金額_26': '',
  '**明細-備考①_26': '2865V29201',
  '**明細-行番号_27': 27,
  '**明細-名称_27': 'どっと原価NEO 交通費B for 大臣',
  '**明細-数量_27': '',
  '**明細-標準単価_27': 10000,
  '**明細-標準金額_27': 0,
  '**明細-仕切率_27': 0.75,
  '**明細-仕切単価_27': 7500,
  '**明細-仕切金額_27': 0,
  '**明細-保守金額_27': '',
  '**明細-備考①_27': '2865V29501',
  '**明細-行番号_28': 28,
  '**明細-名称_28': 'どっと原価NEO 出張費A for 大臣',
  '**明細-数量_28': 1,
  '**明細-標準単価_28': 5000,
  '**明細-標準金額_28': 5000,
  '**明細-仕切率_28': 0.75,
  '**明細-仕切単価_28': 3750,
  '**明細-仕切金額_28': 3750,
  '**明細-保守金額_28': '',
  '**明細-備考①_28': '2865V29901',
  '**明細-行番号_29': 29,
  '**明細-名称_29': '＜　小　計　＞',
  '**明細-数量_29': '',
  '**明細-標準単価_29': '',
  '**明細-標準金額_29': 685000,
  '**明細-仕切率_29': '',
  '**明細-仕切単価_29': '',
  '**明細-仕切金額_29': 513750,
  '**明細-保守金額_29': '',
  '**明細-備考①_29': '',
  '**明細-行番号_30': 30,
  '**明細-名称_30': '＜KDSS保守＞',
  '**明細-数量_30': '',
  '**明細-標準単価_30': '',
  '**明細-標準金額_30': '',
  '**明細-仕切率_30': '',
  '**明細-仕切単価_30': '',
  '**明細-仕切金額_30': '',
  '**明細-保守金額_30': '',
  '**明細-備考①_30': '',
  '**明細-行番号_31': 31,
  '**明細-名称_31': 'KDSS保守 どっと原価NEO ｿﾌﾄｳｪｱ ｽﾀﾝﾀﾞｰﾄﾞ(1000円) for 大臣',
  '**明細-数量_31': 396,
  '**明細-標準単価_31': 1000,
  '**明細-標準金額_31': 396000,
  '**明細-仕切率_31': 0.75,
  '**明細-仕切単価_31': 750,
  '**明細-仕切金額_31': 297000,
  '**明細-保守金額_31': '',
  '**明細-備考①_31': '3122V92401',
  '**明細-行番号_32': 32,
  '**明細-名称_32': 'KDSS保守 どっと原価NEO ﾃﾝﾌﾟﾚｰﾄ ｽﾀﾝﾀﾞｰﾄﾞ(1000円) for 大臣',
  '**明細-数量_32': 78,
  '**明細-標準単価_32': 1000,
  '**明細-標準金額_32': 78000,
  '**明細-仕切率_32': 0.75,
  '**明細-仕切単価_32': 750,
  '**明細-仕切金額_32': 58500,
  '**明細-保守金額_32': '',
  '**明細-備考①_32': '3122V93001',
  '**明細-行番号_33': 33,
  '**明細-名称_33': 'KDSS保守 どっと原価NEO ﾗｲｾﾝｽ ｽﾀﾝﾀﾞｰﾄﾞ(1000円) for 大臣',
  '**明細-数量_33': 528,
  '**明細-標準単価_33': 100,
  '**明細-標準金額_33': 52800,
  '**明細-仕切率_33': 0.75,
  '**明細-仕切単価_33': 75,
  '**明細-仕切金額_33': 39600,
  '**明細-保守金額_33': '',
  '**明細-備考①_33': '3122V92601',
  '**明細-行番号_34': 34,
  '**明細-名称_34': '@526800/年 × 1年',
  '**明細-数量_34': '',
  '**明細-標準単価_34': '',
  '**明細-標準金額_34': '',
  '**明細-仕切率_34': '',
  '**明細-仕切単価_34': '',
  '**明細-仕切金額_34': '',
  '**明細-保守金額_34': '',
  '**明細-備考①_34': '',
  '**明細-行番号_35': 35,
  '**明細-名称_35': '＜　小　計　＞',
  '**明細-数量_35': '',
  '**明細-標準単価_35': '',
  '**明細-標準金額_35': 526800,
  '**明細-仕切率_35': '',
  '**明細-仕切単価_35': '',
  '**明細-仕切金額_35': 395100,
  '**明細-保守金額_35': '',
  '**明細-備考①_35': '',
  '**明細-単位_1': '式',
  '**明細-単位_2': '式',
  '**明細-単位_3': '式',
  '**明細-単位_4': '式',
  '**明細-単位_5': '式',
  '**明細-単位_6': '式',
  '**明細-単位_7': '式',
  '**明細-単位_8': '式',
  '**明細-単位_9': '式',
  '**明細-単位_10': '式',
  '**明細-単位_11': '式',
  '**明細-単位_12': '式',
  '**明細-単位_13': '式',
  '**明細-単位_14': '式',
  '**明細-単位_15': '式',
  '**明細-単位_16': '式',
  '**明細-単位_17': '式',
  '**明細-単位_18': '式',
  '**明細-単位_19': '式',
  '**明細-単位_20': '式',
  '**明細-単位_21': '式',
  '**明細-単位_22': '式',
  '**明細-単位_23': '式',
  '**明細-単位_24': '式',
  '**明細-単位_25': '式',
  '**明細-単位_26': '式',
  '**明細-単位_27': '式',
  '**明細-単位_28': '式',
  '**明細-単位_29': '式',
  '**明細-単位_30': '式',
  '**明細-単位_31': '式',
  '**明細-単位_32': '式',
  '**明細-単位_33': '式',
  '**明細-単位_34': '式',
  '**明細-単位_35': '式',
  '**仕切金額合計-税抜': 2729350,
  '**担当者部門コード': 1,
  '**下書完成区分': 1,
  '**販売店区分': 100,
};
